import { Observable } from 'rxjs';
import { UnSubscribeRequest } from '../models/api-models';

export abstract class IDishService {
  public abstract unsubscribe(request: UnSubscribeRequest): Observable<any>;
}
